<template>
  <div class="card card-custom gutter-b example example-compact">
    <div class="card-header">
      <div class="card-title">
        <router-link to="/admin/product-categories" class="mr-5">
          <b-icon icon="arrow-left" scale="1.5"></b-icon>
        </router-link>
        <h3>Produkt-Kategorie bearbeiten</h3>
      </div>
    </div>
    <div class="card-body">
      <div class="listing-form-main">
        <ValidationObserver ref="newCategoryForm">
          <b-form class="form" @submit.stop.prevent="onSubmit"> 
            <div class="row">
              <div class="col-md-6 form-div">
                <b-form-group id="fieldset-horizontal">
                  <vue-dropzone
                    name="categoryPictures"
                    ref="uploadCategoryImage"
                    id="example-input-0 dropzone"
                    :useCustomSlot="true"
                    :options="dropzoneOptions"
                    @vdropzone-file-added="(file) => uploadFile(file)"
                    @vdropzone-removed-file="handleRemoveImage"
                    aria-describedby="input-0-live-feedback"
                  >
                    <div class="dropzone dropzone-default" id="kt_dropzone_1">
                      <div class="dropzone-msg dz-message needsclick">
                        <h4>Bitte ein Bild hochladen</h4>
                        <h5>Datei hierhin ziehen oder klicken zum Upload</h5>
                        <p>
                          Erlaubte Formate: JPEG, PNG
                          <br />Maximale Upload-Größe: 5MB
                        </p>
                      </div>
                    </div>
                  </vue-dropzone>
                </b-form-group>

                <b-form-group id="fieldset-horizontal">
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :custom-messages="{
                      required: 'Der Kategorie-Name ist erforderlich',
                    }"
                  >
                    <v-text-field
                    :error-messages="errors[0]"
                      autocomplete="new-password"
                      v-model="form.categoryName"
                      label="Kategorie-Name"
                      @input="getSlug(form.categoryName)"
                      outlined
                    ></v-text-field>
                    <!-- <span class="form-errors">{{ errors[0] }}</span> -->
                  </ValidationProvider>
                </b-form-group>

                <b-form-group id="fieldset-horizontal">
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :custom-messages="{
                      required: 'Die Kategorie-Beschreibung ist erforderlich',
                    }"
                  >
                    <v-textarea
                    :error-messages="errors[0]"
                      autocomplete="new-password"
                      outlined
                      name="input-7-4"
                      label="Kategorie-Beschreibung"
                      v-model="form.categoryDescription"
                      @blur="getEditorData(form.categoryDescription)"
                    ></v-textarea>
                    <!-- <span class="form-errors">{{ errors[0] }}</span> -->
                  </ValidationProvider>
                </b-form-group>

                <b-form-group id="fieldset-horizontal">
                 <ValidationProvider
                    type="number"
                    rules="min_value:0"
                    v-slot="{ errors }"
                    :custom-messages="{
                      min_value: 'Die MWSt. muss 0 oder größer sein',
                    }"
                  >
                    <v-text-field
                      autocomplete="new-password"
                      v-model="form.vatPercent"
                      :error-messages="errors[0]"
                      label="MWSt. (%)"
                      outlined
                    ></v-text-field>
                    <!-- <span>{{ errors[0] }}</span> -->
                  </ValidationProvider>
                </b-form-group>


                <!-- Meta description added -->
                <div class="row">
                  <div class="col-md-12">
                    <b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        rules="required|max160"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Kategorie Meta Beschreibung ist erforderlich',
                        }"
                      >
                        <!-- <ckeditor
                          v-model="form.productMetaDescription"
                          :config="editorConfig"
                        ></ckeditor> -->
                        <v-text-field
                          v-model="form.categoryMetaDescription"
                          :error-messages="errors[0]"
                          label="Kategorie Meta Beschreibung für SEO (max. 160 Zeichen, Standard: Kategorie Beschreibungstext)"
                          outlined
                          @blur="restorePopUp(e=1)"
                        ></v-text-field> 
                        <span class="text-danger" v-if="form.categoryMetaDescription.length > 160">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                </div>
                <v-divider></v-divider>
                <div class="row">
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        rules="required|max50"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Kategorie Meta Name ist erforderlich',
                        }"
                      >
                        <v-text-field
                          v-model="form.categoryMetaTitle"
                          :error-messages="errors[0]"
                          label="Kategorie Meta Name für SEO (max. 50 Zeichen, Standard: Kategorie Name)"
                          outlined
                          @blur="restorePopUp(e=2)"
                        ></v-text-field>
                        <span class="text-danger" v-if="form.categoryMetaTitle && form.categoryMetaTitle.length > 50">{{ errors[0] }}</span>
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                  <div class="col-md-6">

                  </div>
                </div>
                <v-divider></v-divider>
                <div class="row">
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Kategorie Canonical Link ist erforderlich',
                        }"
                      >
                        <v-text-field
                          v-model="form.categoryCanonicalLink"
                          :error-messages="errors[0]"
                          label="Kategorie Canonical Link für SEO (Standard: Kategorie URL)"
                          outlined
                          @blur="restorePopUp(e=3)"
                        ></v-text-field>
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <ValidationProvider
                        rules="required"
                        v-slot="{ errors }"
                        :custom-messages="{
                          required: 'Kategorie Meta Robots ist erforderlich',
                        }"
                      >
                        <v-select
                          :items="robotValues"
                          v-model="form.categoryMetaRobots"
                          :error-messages="errors[0]"
                          item-text="lable"
                          item-value="value"
                          label="Kategorie Meta Robots Einstellung für SEO (Standard: index, follow)"
                          outlined clearable
                        />
                      </ValidationProvider>
                    </b-form-group>
                  </div>
                </div>
                <v-divider></v-divider>                
                <b-form-group>
                  <v-switch
                    v-model="status"
                    inset
                    :label="status == true ? 'Aktiviert' : 'Deaktiviert'"
                    class="d-inline-block"
                  ></v-switch>
                </b-form-group>
                <v-divider></v-divider>  

                <div class="fo-row-btn text-right">
                  <v-btn
                    class="submit-btn-fill-outline"
                    @click="goToBack"
                  >
                    Abbrechen
                  </v-btn>
                  <v-btn
                    type="submit"
                    :disabled="isDisabled"
                    ref="kt_form_submit_btn"
                    class="submit-btn-fill-color"
                  >
                    {{ submitText }}
                  </v-btn>
                  <!-- <br />
              <span class="form-errors" v-if="formError"
                >One or more fields has error. Please check form again.</span
              > -->
                </div>
              </div>
            </div>
          </b-form>
        </ValidationObserver>
        <v-dialog v-model="statusDialog" width="500">
          <v-card>
            <v-card-title class="headline grey lighten-2">
              Bitte bestätigen
            </v-card-title>
            <v-card-text>
              <span>Möchten Sie den Wert wiederherstellen?</span>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn
                :disabled="disabledCancel"
                class="no-button"
                @click="hideModal"
              >
                Nein
              </v-btn>
              <v-btn
                type="submit"
                @click="restore()"
                ref="kt_form_submit_btn"
                class="yes-button"
                :loading="yesActionLoading"
              >
                Ja
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </div>
    <notifications group="categories" position="bottom right" />
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import axios from "axios";
import Notifications from "vue-notification";
import JwtService from "@/core/services/jwt.service";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import HtmlClass from "@/core/services/htmlclass.service";
import KTScrollTop from "@/components/admin/layout/extras/ScrollTop";
import Loader from "@/components/admin/layout/Loader.vue";
import metarobots from "@/config/constant";

import {
  ADD_BODY_CLASSNAME,
  REMOVE_BODY_CLASSNAME,
} from "@/core/services/store/htmlclass.module.js";
import adminAPI from "@/api/admin";

Vue.use(Notifications);
import { extend } from "vee-validate";
extend("max160", {
  message: (field) => "Kategorie Meta Beschreibung: maximal 160 Zeichen",
  validate: (value) => {
    var regx = /^.{0,160}$/;
    var validInput = regx.test(value);
    if (validInput) {
      return true;
    } else {
      false;
    }
  },
});

extend("max50", {
  message: (field) => "Kategorie Meta Name: maximal 50 Zeichen",
  validate: (value) => {
    var regx = /^.{0,50}$/;
    var validInput = regx.test(value);
    if (validInput) {
      return true;
    } else {
      false;
    }
  },
});
export default {
  name: "EditCategory",
  created() {
    if (!this.isAuthenticated) {
      this.$router.push({ name: "Login" });
    } else {
      // show page loading
      this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
      HtmlClass.init(this.layoutConfig());
      this.userId = localStorage.getItem("local_products_user_access_id");
      this.getCategoryData();
      this.robotValues = metarobots;
    }
  },
  components: {
    vueDropzone: vue2Dropzone,
  },
  data() {
    return {
      dropzoneOptions: {
        url: "https://marktplatzgenius.lcmx.at/Gustoreich/api/v1/update-category",
        thumbnailWidth: 150,
        maxFilesize: 5,
        maxFiles: 1,
        addRemoveLinks: true,
        autoProcessQueue: false,
        timeout: 20000000,
        acceptedFiles: ".jpeg, .jpg, .png",
        uploadMultiple: false,
        uploadprogress: false,
      },
      submitText: "Speichern",
      formError: false,
      userId: null,
      formData: [],
      robotValues: [],
      btnDisable: false,
      imageChanged: "0",
      currentImage: null,
      status: false,
      form: {
        file: null,
        categoryName: null,
        categoryDescription: null,
        vatPercent: 0,
        categoryMetaDescription: '',
        categoryMetaTitle: '',
        categoryCanonicalLink: '',
        categoryMetaRobots: ''
      },
      radioItems: [
        {
          key: "Enable",
          value: "1",
        },
        {
          key: "Disable",
          value: "0",
        },
      ],
      category_name_slug:'',
      meta_name_flag:false,
      meta_description_flag:false,
      statusDialog: false,
      restoreField:null
    };
  },
  watch: {
    "form.categoryName": function (value) {
      if (this.meta_name_flag) {
        this.form.categoryMetaTitle = value.substr(0, 50)
      }
    },
  },
  methods: {
    goToBack() {
      this.$router.push({ name: "product-categories" });
    },
    removeImage() {
      this.form.file = null;
      this.currentImage = null;
    },
    handleRemoveImage() {
      this.form.file = null;
      this.currentImage = null;
    },
    getCategoryData() {
      adminAPI
        .editRoomCategory({ id: this.$route.params.id })
        .then((response) => {
          if (response.status == "success") {
            this.form.categoryName = response.data.category_name;
            this.form.categoryDescription = response.data.description;
            this.form.categoryMetaDescription = response.data.meta_description;
            this.form.categoryMetaTitle = response.data.title;
            this.form.categoryCanonicalLink = response.data.canonical_link;
            this.form.categoryMetaRobots = response.data.meta_robots;
            this.form.file = response.data.image_path;
            this.form.vatPercent = response.data.vat;

            if (this.form.categoryMetaTitle == ''|| this.form.categoryMetaTitle == null || this.form.categoryMetaTitle == undefined){
              this.form.categoryMetaTitle = this.form.categoryName;
            }

            if (this.categoryMetaDescription == '' || this.categoryMetaDescription == null || this.categoryMetaDescription == undefined){
              this.categoryMetaDescription = this.form.categoryDescription
            }

            if (this.form.categoryCanonicalLink == '' || this.form.categoryCanonicalLink == null || this.form.categoryCanonicalLink == undefined){
                this.getSlug(this.form.categoryName)
            }

            

            if (this.form.categoryName == this.form.categoryMetaTitle) {
                this.meta_name_flag = true;
            }

            if (this.form.categoryDescription == this.form.categoryMetaDescription) {
               this.meta_description_flag = true;
            }

            this.currentImage = response.data.image_path;
            this.status = response.data.is_status == 1 ? true : false;
            if (response.data.image_path.indexOf(".jpg") !== -1) {
              var file = {
                size: 12345,
                name: response.data.image_path,
                type: "image/jpeg",
              };
              this.$refs.uploadCategoryImage.manuallyAddFile(
                file,
                response.data.image_path
              );
            }
            if (response.data.image_path.indexOf(".png") !== -1) {
              var file = {
                size: 12345,
                name: response.data.image_path,
                type: "image/png",
              };
              this.$refs.uploadCategoryImage.manuallyAddFile(
                file,
                response.data.image_path
              );
            }
            this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
          } else {
            this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
            this.$notify({
              group: "categories",
              type: "error",
              position: "bottom right",
              text: response.msg,
              duration: 3000,
            });
          }
        })
        .catch((err) => {
          this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading");
          this.$notify({
            group: "categories",
            type: "error",
            position: "bottom right",
            text: err,
            duration: 3000,
          });
        });
    },
    uploadFile(file) {
      setTimeout(() => {
        if (file.status == "queued") {
          this.imageChanged = "1";
          this.form.file = file;
        }
      }, 1000);
    },
    onSubmit() {
      this.$refs.newCategoryForm.validate().then((success) => {
        if (success && this.form.file !== null) {
          this.btnDisable = true;
          this.submitText = "Wird gespeichert...";
          let fd = new FormData();
          fd.append("name", this.form.categoryName);
          fd.append("description", this.form.categoryDescription);
          fd.append("meta_description", this.form.categoryMetaDescription);
          fd.append("title", this.form.categoryMetaTitle);
          fd.append("canonical_link", this.form.categoryCanonicalLink);
          fd.append("meta_robots", this.form.categoryMetaRobots);
          fd.append("image_changed", this.imageChanged);
          fd.append("file", this.form.file);
          fd.append("id", this.$route.params.id);
          fd.append("status", this.status == true ? '1' : '0');
          let productVatPercent = 0;
            if(this.form.vatPercent > 0)
              productVatPercent = this.form.vatPercent;

          fd.append("category_vat", productVatPercent);
          setTimeout(() => {
            adminAPI
              .updateRoomCategory(fd)
              .then((response) => {
                if (response.status == "success") {
                  this.submitText = "Speichern"
                  this.btnDisable = false;
                  this.$notify({
                    group: "categories",
                    type: "success",
                    position: "bottom right",
                    text: response.msg,
                    duration: 5000,
                  });
                  setTimeout(() => {
                    this.$router.push({ name: "product-categories" });
                  }, 2000);
                } else {
                  this.btnDisable = false;
                  this.submitText = "Speichern";
                  this.$notify({
                    group: "categories",
                    type: "error",
                    position: "bottom right",
                    text: response.msg,
                    duration: 5000,
                  });
                }
              })
              .catch((err) => {
                this.btnDisable = false;
                this.submitText = "Speichern";
                this.$notify({
                  group: "categories",
                  type: "error",
                  position: "bottom right",
                  text: err,
                  duration: 5000,
                });
              });
          }, 2000);
        } else {
          this.$notify({
            group: "categories",
            type: "error",
            position: "bottom right",
            text: 'fehlender obligatorischer Wert oder falsches Format',
            duration: 5000,
          });
          this.formError = true;
          this.btnDisable = false;
          this.submitText = "Speichern";
        }
      });
    },
    getSlug(name) {
      if (name){
        adminAPI
        .createSlug({ name: name })
        .then((response) => {
          if (response.status == "success") {
              console.log('createSlug', response)
             
                this.category_name_slug = response.data.slug
                // if (this.meta_name_flag) {
                //   this.form.categoryMetaTitle = name.substr(0, 50)
                // }

              if(this.category_name_slug) {
                if (window.location.hostname == 'stage.marktplatzgenius.lcmx.at' || window.location.hostname == 'localhost') {
                  this.form.categoryCanonicalLink = 'https://stage.marktplatzgenius.lcmx.at/produkt/'+this.category_name_slug+'?page=1'
                } else {
                  this.form.categoryCanonicalLink = 'https://marktplatzgenius.lcmx.at/produkt/'+this.category_name_slug+'?page=1'
                }  
              }
          } 
        }).catch((err) => {
            console.log(err)
        });
      }
    },
    getEditorData(htmlData) {
      if (this.meta_description_flag) {
        this.form.categoryMetaDescription = htmlData.substr(0,160);
      }
    },
    restorePopUp(e){
      if((e=='1') && (!this.form.categoryMetaDescription)&& (this.form.categoryDescription) && (this.meta_description_flag)){
        this.restoreField = e;
        this.statusDialog = true;
      }else if((e=='2') && (!this.form.categoryMetaTitle) && (this.form.categoryName) && (this.meta_name_flag)) {
        this.restoreField = e;
        this.statusDialog = true;
      }else if((e=='3') && (!this.form.categoryCanonicalLink) && (this.form.categoryName) && (this.meta_name_flag)){
        this.restoreField = e;
        this.statusDialog = true;
      }
    },
    hideModal(){
      this.statusDialog = false
    },
    restore(){
      if(this.restoreField == '1') {
        this.getEditorData(this.form.categoryDescription)
      }else if(this.restoreField == '2') {
        this.form.categoryMetaTitle = this.form.categoryName.substring(0,50);
      }else if(this.restoreField == '3') {
        this.getSlug(this.form.categoryName);
      }
      this.statusDialog = false
    }
  },
  computed: {
    ...mapGetters([
      "isAuthenticated",
      "breadcrumbs",
      "pageTitle",
      "layoutConfig",
      "currentUser",
    ]),
    /**
     * Check if the page loader is enabled
     * @returns {boolean}
     */
    loaderEnabled() {
      return !/false/.test(this.layoutConfig("loader.type"));
    },
    /**
     * Check if container width is fluid
     * @returns {boolean}
     */
    contentFluid() {
      return this.layoutConfig("content.width") === "fluid";
    },
    /**
     * Page loader logo image using require() function
     * @returns {string}
     */
    loaderLogo() {
      return process.env.BASE_URL + this.layoutConfig("loader.logo");
    },
    /**
     * Check if the left aside menu is enabled
     * @returns {boolean}
     */
    asideEnabled() {
      return !!this.layoutConfig("aside.self.display");
    },
    /**
     * Set the right toolbar display
     * @returns {boolean}
     */
    toolbarDisplay() {
      // return !!this.layoutConfig("toolbar.display");
      return true;
    },
    /**
     * Set the subheader display
     * @returns {boolean}
     */
    subheaderDisplay() {
      return !!this.layoutConfig("subheader.display");
    },

    isDisabled: function () {
      return this.btnDisable;
    },
  },
};
</script>

<style scoped>
h3 {
  font-family: "ubuntu";
  color: #000;
}

.form-div {
  margin: auto;
}

.form-errors {
  color: red;
}

.submit-button {
  background-color: #3d5a80 !important;
}

.submit-button:hover {
  background-color: #002c47 !important;
}

.spinner.spinner-right {
  padding-right: 3.5rem !important;
}

.remove-icon {
  cursor: pointer;
  position: absolute;
  top: 0;
}

.dropzone .dz-preview .dz-progress {
  /* progress bar covers file name */
  display: none !important;
  opacity: 0 !important;
}
</style>
